import styled from 'styled-components';

const hexToRgba = (hex: string, opacity: number) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const Wrapper = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-width: 100%;
`;

export const ErrorMessage = styled.span`
    font-family: 'Elza', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.2px;
`;

export const ErrorCode = styled.small`
    align-self: flex-start;
    margin-top: 8px;
    font-family: 'Elza', sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: #637381;
`;

export const Footer = styled.footer`
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    margin: 15px 10px 5px 0;
    gap:8px;
`;

export const ActionButton = styled.button<{ $strong?: boolean }>`
    width: 172px;
    height: 40px;
    border-radius: 100px;
    background-color: ${({ theme, $strong }) => (
    $strong ? theme.colors.accent.primary : hexToRgba(theme.colors.accent.primary,0.15)) } ;

    font-family: 'Elza', sans-serif;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: ${({ theme, $strong }) => ($strong ? theme.colors.surface.high : theme.colors.accent.primary)};

    &:hover {
        background-color: ${({ theme, $strong }) => (
    $strong ? theme.colors.accent.primary : hexToRgba(theme.colors.accent.primary,0.15)) } ;
    }
`;
